import { AddDoctorSignature } from 'domain/usecases/doctor/add-signature'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteAddDoctorSignature implements AddDoctorSignature {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  upload(params: AddDoctorSignature.Params): Promise<AddDoctorSignature.Model> {
    return this.doctorRepository.addFavorite(params)
  }
}
